<mat-dialog-content>
	<div class="searchWrapper flex flex-col justify-stretch">
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					(keypress)="onCreateTag($event)"
					[formControl]="searchinput"
					cdkFocusInitial
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<div
					class="flex-center h-full"
					matSuffix
				>
					<mat-icon inline>search</mat-icon>
				</div>
			</mat-form-field>
		</div>
		<div class="searchContainer flex flex-col">
			<mat-list
				*ngIf="this.data$filtered | async as dataFiltered"
				dense
			>
				<ng-container *ngFor="let item of dataFiltered; trackBy: trackFiltered">
					<mat-list-item
						(click)="this.isLocked(item) ? this.showLockedHint() : this.selectItem(item)"
						class="cursor-pointer"
						matRipple
					>
						<ng-container>
							<mat-checkbox
								(click)="$event.preventDefault()"
								[checked]="item.selected"
								[disabled]="this.isLocked(item)"
								[labelPosition]="'after'"
								class="mat-checkbox-flex w-full"
								color="primary"
							>
								<span class="flex items-center">
									<span
										[style.backgroundColor]="tagDisplayColor(item)"
										class="project-color-dot !mr-2 flex-shrink-0 !cursor-default"
									></span>
									<span>{{ item.name }}</span>
								</span>
							</mat-checkbox>
						</ng-container>
					</mat-list-item>
				</ng-container>
				<ng-container *ngTemplateOutlet="noItems; context: { data: dataFiltered }"></ng-container>
			</mat-list>
			<ng-template
				#noItems
				let-dataFiltered="data"
			>
				<div
					*ngIf="dataFiltered.length === 0"
					class="flex flex-col items-center justify-center p-2"
				>
					<div class="mat-hint">{{ 'utils.noitems' | translate }}</div>
				</div>
			</ng-template>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="mat-action-filled flex flex-row">
	<button
		(click)="this.closeDialog()"
		[disabled]="(this.isLoading$ | async) || !(selected$change | async)"
		class="mat-button-filled flex-grow"
		color="primary"
		mat-flat-button
	>
		{{ 'utils.apply' | translate }}
	</button>
	<button
		(click)="this.createTagDialog()"
		[disabled]="(this.isLoading$ | async) || !(this.workspace$createPermission | async)"
		[matTooltip]="(this.workspace$createPermission | async) ? null : 'workspace.errors.admin-create-tag' |translate"
		[matTooltipDisabled]="this.workspace$createPermission | async"
		class="mat-button-filled !ml-0"
		color="primary"
		mat-flat-button
	>
		<mat-icon>add</mat-icon>
	</button>
</mat-dialog-actions>
